<template>
  <v-dialog
    v-model="showDialog"
    :persistent="!!createdApiKey"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        text
        color="primary"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon left>
          add
        </v-icon>
        {{ $t('create') }} {{ $t('apiKey._') }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ $t('create') }} {{ $t('apiKey._') }}
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model.trim="name"
          :label="$t('name')"
          hint="A descriptive name to remember where the key is used"
          persistent-hint
          outlined
          append-icon="add"
          :disabled="!!createdApiKey"
          @click:append="(name && !createdApiKey) ? createApiKey() : null"
        />

        <v-alert
          color="warning"
          icon="warning"
          text
          dense
          prominent
          class="my-8"
        >
          Once the API Key is created it is shown once and cannot be shown later.
          Be sure to copy and paste the key where it needs to be used before closing
          this dialog.

          <v-switch
            v-model="keyCopied"
            label="I copied and used the key"
            color="primary"
            class="ml-4 justify-center"
          />
        </v-alert>

        <v-text-field
          :value="createdApiKey && createdApiKey.key"
          label="API Key"
          placeholder="Once created, the API Key will appear here"
          hint="An API Key is like a password, treat it as such"
          persistent-hint
          outlined
          readonly
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          text
          color="primary"
          :disabled="createdApiKey && !keyCopied"
          @click="showDialog = false"
        >
          {{ createdApiKey ? $t('close') : $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UserApiKeyAuthProviderClient } from 'mongodb-stitch-browser-sdk'
import { client } from '@/plugins/stitch'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      createdApiKey: null,
      keyCopied: false,
      name: null,
      showDialog: false
    }
  },
  async mounted () {
    this.apiKeyClient = client.auth
      .getProviderClient(UserApiKeyAuthProviderClient.factory)
  },
  methods: {
    async createApiKey () {
      this.createdApiKey = await this.apiKeyClient.createApiKey(this.name)

      this.$notify('API Key successfully created')
      this.$emit('created', this.createdApiKey)
    }
  }
}
</script>

<style>

</style>
